import React, { useEffect, useRef } from 'react';

const FloatingParticles = ({ count = 20 }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Limpiar partículas existentes
    container.innerHTML = '';

    // Crear partículas
    for (let i = 0; i < count; i++) {
      const particle = document.createElement('div');
      particle.className = 'particle';
      
      // Posición aleatoria
      particle.style.left = Math.random() * 100 + '%';
      particle.style.animationDelay = Math.random() * 15 + 's';
      particle.style.animationDuration = (15 + Math.random() * 10) + 's';
      
      // Tamaño aleatorio
      const size = 2 + Math.random() * 4;
      particle.style.width = size + 'px';
      particle.style.height = size + 'px';
      
      // Opacidad aleatoria
      particle.style.opacity = 0.3 + Math.random() * 0.4;
      
      container.appendChild(particle);
    }

    // Cleanup
    return () => {
      container.innerHTML = '';
    };
  }, [count]);

  return <div ref={containerRef} className="floating-particles" />;
};

export default FloatingParticles;
